/* eslint react-hooks/exhaustive-deps: 0 */

import { Dictionary, keyBy, remove, uniqBy } from 'lodash';
import React, { createContext, ReactNode, useEffect, useState } from 'react';
import { getHotelsWithEngine } from '../../../services/travel-arrangement-api/travel-arrangement-api.service';

export interface Room {
  address1: string;
  city: string;
  stateCode: string;
  country: string;
  description: string;
  imagePath: string;
  price: number;
  profileUrl: string;
  propertyId: string;
  propertyName: string;
  postalCode?: number;
  provider?: string;
  currency?: string;
  distance?: number;
  latitude?: number;
  longitude?: number;
  mobilStarRating?: number;
  numReviews?: number;
  priceHigh?: number;
  rating?: number;
  universalId?: number;
}

interface Props {
  children: ReactNode | ReactNode[];
  weddingLocation: string;
  weddingDate: string;
  exclude: string[];
}

export const TransientRoomsContext = createContext<Room[] | []>([]);

export const TransientRoomsProvider: React.FC<Props> = ({ children, weddingLocation, weddingDate, exclude }) => {
  const [excludeLookup, setExcludeLookup] = useState<Dictionary<string>>(() => keyBy(exclude));
  const [rooms, setRooms] = useState<Room[]>([]);

  useEffect(() => {
    setExcludeLookup(keyBy(exclude));
  }, [exclude]);

  useEffect(() => {
    const hotelPlannerRooms = remove(rooms, (room: Room) => !excludeLookup[room.propertyId]);
    setRooms(uniqBy(hotelPlannerRooms, room => room.propertyId));
  }, [excludeLookup]);

  useEffect(() => {
    getHotelsWithEngine(excludeLookup, weddingDate, weddingLocation).then((rooms: Room[]) => setRooms(rooms));
  }, [weddingLocation, weddingDate]);

  return <TransientRoomsContext.Provider value={rooms}>{children}</TransientRoomsContext.Provider>;
};
